
import { useEffect } from 'react';
import HeaderV5 from '@/components/landing-v5/HeaderV5';
import HeroSectionV4 from '@/components/landing-v4/HeroSectionV4';
import PainPointsSection from '@/components/landing-v4/PainPointsSection';
import WhatIsPACTSectionV4 from '@/components/landing-v4/WhatIsPACTSectionV4';
import WhyShowUpWorksSection from '@/components/landing-v5/WhyShowUpWorksSection';
import FeaturesSectionV4 from '@/components/landing-v4/FeaturesSectionV4';
import FAQSection from '@/components/landing-v5/FAQSection';
import InternalLinksSection from '@/components/landing-v5/InternalLinksSection';
import FinalCTASection from '@/components/landing-v4/FinalCTASection';
import FloatingCTA from '@/components/landing-v4/FloatingCTA';
import FooterV5 from '@/components/landing-v5/FooterV5';
import SEOSchema from '@/components/SEOSchema';
import ErrorBoundary from '@/components/ErrorBoundary';

const LandingPageV5 = () => {

  // SEO optimization
  useEffect(() => {
    console.log('[LandingPageV5] mounted at', new Date().toISOString());
    document.title = "Show Up Again - Don't Overthink It | PACT Habit Tracker";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', "Don't overthink it. Show up again. The minimalist habit tracker that comes before habits & goals. Join 67+ people ready to build lasting habits with the PACT framework. Get early access now!");
    }

    // Enhanced meta keywords for better SEO
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', "PACT habit tracker, don't overthink habits app, minimalist commitment tracker, show up again motivation, simple habit building app, habit tracker before goals, PACT framework habits, daily commitment app, overthinking habits solution");
    }

    // Canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://showupagain.com/landing-page');
    }
  }, []);

  return (
    <>
      {/* SEO Schema Markup */}
      <SEOSchema />
      
      <div className="min-h-screen bg-gradient-to-br from-purple-500 via-purple-400 to-indigo-500">
        {/* Header with Logo */}
        <HeaderV5 />
        
        {/* Floating CTA Button */}
        <FloatingCTA />
        
        {/* Hero Section */}
        <main>
          <div className="pt-40">
            <HeroSectionV4 />
          </div>
          
          {/* Pain Points Section */}
          <PainPointsSection />
          
          {/* What is PACT Section */}
          <WhatIsPACTSectionV4 />
          
          {/* Why Show Up Works Section */}
          <ErrorBoundary>
            <WhyShowUpWorksSection />
          </ErrorBoundary>
          
          {/* Features Section */}
          <FeaturesSectionV4 />
          
          {/* FAQ Section */}
          <ErrorBoundary>
            <FAQSection />
          </ErrorBoundary>
          
          {/* Internal Links Section */}
          <ErrorBoundary>
            <InternalLinksSection />
          </ErrorBoundary>
          
          {/* Final CTA Section */}
          <FinalCTASection />
        </main>
        
        {/* Footer */}
        <FooterV5 />
      </div>
    </>
  );
};

export default LandingPageV5;
